module.exports = __webpack_public_path__ + "img/waskita.f556a377.jpg";